// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/pagination/style/index.less
// module id = 1115
// module chunks = 1